var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1441_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.679 126.127C202.847 78.8066 173.54 31.3915 126.22 20.2228C78.8988 9.05407 31.4837 38.3611 20.315 85.6818C9.14632 133.003 38.4533 180.418 85.7741 191.586C133.095 202.755 180.51 173.448 191.679 126.127Z",
    fill: "url(#paint0_linear_1441_2091)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.225 107.454C101.272 107.454 96.4296 105.985 92.311 103.233C88.1923 100.481 84.9822 96.5694 83.0866 91.9931C81.191 87.4167 80.695 82.3809 81.6614 77.5227C82.6278 72.6644 85.0131 68.2018 88.5157 64.6992C92.0183 61.1966 96.481 58.8113 101.339 57.8449C106.197 56.8785 111.233 57.3745 115.81 59.2701C120.386 61.1657 124.298 64.3758 127.049 68.4944C129.801 72.6131 131.27 77.4553 131.27 82.4087C131.27 89.0511 128.632 95.4214 123.935 100.118C119.238 104.815 112.868 107.454 106.225 107.454ZM106.225 61.3454C102.059 61.3454 97.987 62.5807 94.5231 64.8952C91.0593 67.2097 88.3595 70.4993 86.7653 74.3481C85.171 78.197 84.7539 82.4321 85.5667 86.518C86.3794 90.6039 88.3855 94.357 91.3312 97.3027C94.277 100.248 98.0301 102.255 102.116 103.067C106.202 103.88 110.437 103.463 114.286 101.869C118.135 100.274 121.424 97.5747 123.739 94.1109C126.053 90.647 127.289 86.5746 127.289 82.4087C127.278 76.8256 125.056 71.4742 121.108 67.5263C117.16 63.5784 111.808 61.3559 106.225 61.3454Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.378 154.616H61.1122V152.545C60.9328 146.506 61.9674 140.491 64.1549 134.859C66.3423 129.226 69.638 124.09 73.8467 119.754C78.0554 115.419 83.0915 111.972 88.6566 109.618C94.2217 107.265 100.203 106.052 106.245 106.052C112.287 106.052 118.268 107.265 123.833 109.618C129.399 111.972 134.435 115.419 138.643 119.754C142.852 124.09 146.148 129.226 148.335 134.859C150.523 140.491 151.557 146.506 151.378 152.545V154.616ZM65.1337 150.634H147.317C146.851 140.049 142.318 130.052 134.662 122.727C127.007 115.401 116.821 111.312 106.225 111.312C95.6297 111.312 85.443 115.401 77.7879 122.727C70.1328 130.052 65.5998 140.049 65.1337 150.634Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1441_2091",
    x: 9.94092,
    y: 13.8488,
    width: 192.112,
    height: 192.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1441_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1441_2091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1441_2091",
    x1: 1.05911,
    y1: 167.267,
    x2: 40.5378,
    y2: 0.000034999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DD6F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f5ddbcc7ca1371624665b4648d83fe76.svg";
export { ForwardRef as ReactComponent };